export default function SearchIcon({ className }) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			aria-hidden="true"
		>
			<circle
				cx="8.75"
				cy="8.75"
				r="5.75"
				stroke="currentColor"
				strokeWidth="1.6"
			/>
			<path
				d="M13.25 13.25L17 17"
				stroke="currentColor"
				strokeWidth="1.6"
				strokeLinecap="round"
			/>
		</svg>
	)
}
